/*
 * mod='role'
 * author: nicy
 * time: 2019-02-21
 */

import { smb_fetch, getAgpApiUrl } from '../../../../api/operator/fetch';

const getRoleApiUrl = (mod, act) => {
  const result = getAgpApiUrl(mod, act);

  return result;
};

/**
 * 当分配系统角色为代理投放管理员时，需要选择对应服务商账户
 * @return
 */
export const getTotalCostData = (data) => {
  const url = getRoleApiUrl('dashboard', 'get_total_cost');
  const params = $.extend(
    true,
    {
      method: 'GET',
      timeout: 0,
    },
    data,
  );

  return smb_fetch(url, params, false);
};

/**
 * 获取四大数据
 * @return
 */
export const getTopCost = (data) => {
  const url = getRoleApiUrl('dashboard', 'get_top_cost');
  const params = $.extend(
    true,
    {
      method: 'GET',
      timeout: 0,
      isCache: true,
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取效果数据
 * @return
 */
export const getEffect = (data) => {
  const url = getRoleApiUrl('dashboard', 'get_effect');
  const params = $.extend(
    true,
    {
      method: 'GET',
      timeout: 0,
    },
    data,
  );
  return smb_fetch(url, params);
};

export const saveAgencyLayout = (data) => {
  const url = getRoleApiUrl('agency_layout', 'save');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
      isCancel: true,
    },
    data,
  );

  return smb_fetch(url, params);
};

export const getAgencyLayout = (data) => {
  const url = getRoleApiUrl('agency_layout', 'get');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取创意审核数据
 * @return
 */
export const getCreativeReviewData = (data) => {
  const url = getRoleApiUrl('dashboard', 'get_creative_review_analyze');
  const params = $.extend(
    true,
    {
      method: 'GET',
      timeout: 0,
    },
    data,
  );

  return smb_fetch(url, params);
};

export default {
  getTotalCostData,
  getEffect,
  getTopCost,
};
